import {
  StyledSessionList,
  SessionListControls,
  SessionListContent,
  SessionListHint,
  InternalSessionInfo,
  InternalSession,
  InternalSessionList,
  InternalSessionListWrapper,
  Checkmark,
  PopupTopDecorator
} from '../VsBattlePopup/VsBattlePopup.styled';
import { useAudio } from '../../providers/AudioContext';
import { MiniAvatar } from './ArcadeBattlePopup.styled';
import { FigureModel } from '../../models';
import { PopupHeader, BroadsiderHudPopup, IconButton } from '../';
import { playLevel } from '../../providers/BasejumpApiProvider';
import { DiscordSdkContext } from '../../providers/DiscordSdkProvider';
import { useContext, useState } from 'react';
import { useLevels } from '../../hooks';
import { AppContext } from '../../providers/AppContext';
import { AuthContext } from '../../providers/AuthProvider';

const SessionListData = ({ onSelectLevel, selectedLevel, levels }) => {
  const { isDiscord } = useContext(DiscordSdkContext);
  const { playSFX } = useAudio();
  return (
    <InternalSessionList>
      <InternalSessionListWrapper>
        {levels.map((s, index) => {
           const isSelected = s.id === selectedLevel?.id;
           const figure = FigureModel.fromBasejumpAvatar(s.avatar, isDiscord);
           return (
             <InternalSession $locked={s.locked} key={s.id} $selected={s.id === selectedLevel?.id} onClick={() => s.locked ? false : onSelectLevel(s)} onMouseEnter={() => s.locked ? false: playSFX('hover')}>
               <MiniAvatar src={figure.getAvatarThumbSource()}/>
               <InternalSessionInfo >{s.avatar.name}</InternalSessionInfo>
               <Checkmark src={s.locked ? '/assets/lock.svg' : '/assets/done.svg'} style={{ opacity: isSelected || s.locked ? '1' : '0' }}/>
             </InternalSession>
           );
        })}
      </InternalSessionListWrapper>
    </InternalSessionList>
  );
};

const ArcadeBattlePopup = ({ onGameStarted, onSelectOpponent, disabled = false }) => {
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [joinedSession, setJoinedSession] = useState(null);
  const { selectedBroadsider, currentUserEmail } = useContext(AppContext);
  const { basejumpToken, user } = useContext(AuthContext);
  const { levels } = useLevels();
  const [playInProgress, setPlayInProgress] = useState(false);
  const { playSFX } = useAudio();

  const onSelectLevel = (level) => {
    setSelectedLevel(level);
    onSelectOpponent(level.avatar);
    playSFX('menu_button');
  };

  const onPlayLevel = async (level) => {
    setPlayInProgress(true);
    try {
      const session = await playLevel(level.id, selectedBroadsider.getAvatarId(), basejumpToken);
      onGameStarted(session);
    } finally {
      setPlayInProgress(false);
    }
  };

  const battleDisabled = !selectedLevel || playInProgress;
  return (
    <BroadsiderHudPopup overwrightWidth='25vw' overwrightMinWidth='23rem'>
      <PopupTopDecorator/>
      <StyledSessionList>
        <PopupHeader title='Choose Opponent' />
        <SessionListContent>
	  <SessionListHint>
            Battle others to win XP, Bones and Action Items
          </SessionListHint>
          <SessionListData onSelectLevel={onSelectLevel} selectedLevel={selectedLevel} levels={levels}/>
          <SessionListControls>
            <IconButton disabled={battleDisabled || disabled} onClick={() => onPlayLevel(selectedLevel)}>
              <div>Battle</div>
            </IconButton>
          </SessionListControls>
        </SessionListContent>
      </StyledSessionList>
    </BroadsiderHudPopup>
  );
};

export default ArcadeBattlePopup;
